type Args = {
	singleInstrumentationID: string;
	isReadyForProactive?: boolean;
};

/**
 * This utility function doesn't do much
 * The only reason why this exists is because then we can pass in the singleInstrumentationID and get all the ai attributes, without making typo mistakes
 */
export function getAiAttributes({ singleInstrumentationID, isReadyForProactive = false }: Args) {
	const userGeneratedAI = isReadyForProactive ? 0 : 1;
	const proactiveAIGenerated = isReadyForProactive ? 1 : 0;
	return {
		aiFeatureName: 'JQL_Debugger',
		userGeneratedAI,
		proactiveAIGenerated,
		isAIFeature: 1,
		singleInstrumentationID,
	};
}
